import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Reveal from '../components/Reveal';
import { ArrowRight, Starburst } from '../components/Icons';
import { NAV } from '../data/site';
import { PHOTO } from '../data/media';
import './NotFound.css';

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" description="That page has left the table." path="/404" />

      <section className="nf section--dark grain">
        <div className="nf__bg" aria-hidden="true">
          <img src={PHOTO.plate9} alt="" />
        </div>
        <div className="page nf__inner on-dark">
          <Reveal className="nf__mark">
            <Starburst size={52} />
          </Reveal>
          <Reveal as="p" className="eyebrow is-centered" delay={0.08}>
            Error 404
          </Reveal>
          <Reveal as="h1" className="display brand d1" delay={0.14}>
            That page has left the table.
          </Reveal>
          <Reveal as="p" className="lead mx-auto text-center" delay={0.2}>
            The link is broken or the page has moved. Everything else is still where
            you left it.
          </Reveal>

          <Reveal className="nf__links" delay={0.28}>
            {NAV.filter((n) => n.to !== '/').map((n) => (
              <Link key={n.to} to={n.to} className="nf__link">
                {n.label}
              </Link>
            ))}
          </Reveal>

          <Reveal delay={0.36}>
            <Link to="/" className="btn btn--gold">
              <span>Back to the start</span>
              <ArrowRight />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
